/**
 * Generic Column Settings Control
 * Wrapper component that provides button and manages modal state
 */

import { useState } from 'react';
import { ColumnSettingsButton } from './ColumnSettingsButton';
import { ColumnSettingsModal } from './ColumnSettingsModal';
import { useColumnVisibility } from './ColumnVisibilityContext';

interface ColumnSettingsControlProps {
  modalTitle?: string;
  buttonLabel?: string;
  id?: string;
}

export const ColumnSettingsControl = ({ modalTitle, buttonLabel, id }: ColumnSettingsControlProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { columns, updateColumns, resetColumns } = useColumnVisibility();

  return (
    <>
      <ColumnSettingsButton id={id} onClick={() => setIsOpen(true)} label={buttonLabel} />
      <ColumnSettingsModal open={isOpen} onClose={() => setIsOpen(false)} columns={columns} onApply={updateColumns} onReset={resetColumns} title={modalTitle} />
    </>
  );
};
